// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"458f848b","98":"06535864","126":"19741969","147":"78358bad","171":"e5c27d62","374":"7386d940","378":"2e6456ee","453":"00f6265a","466":"f4950f39","507":"e0b1e332","553":"1ba7f1e9","780":"efdbe712"}[chunkId] + ".chunk.js";
};